// Module
var code = `<select id="tagSelect" class="form-control" ng-options="element.name as element.label for element in tagSelectController.elements" ng-model="tagSelectController.selected" ng-change="tagSelectController.onChange()"> <option value="">-- {{ 'Generic.NoneSelected' | translate }} --</option> </select> `;
// Exports
module.exports = code;